import { useErrorInlineNotificationAPI } from '@/components/ErrorInlineNotification/ErrorInlineNotification';
import { isSuccess } from '@/context/services/type';
import { useErrorTrackingSystem } from '@/hooks/useErrorTrackingSystem';
import { useTranslation } from '@/i18n';
import { useNotification } from '@moneyforward/ap-frontend-components';
import { useDeleteApCurrencyRate } from 'ap-openapi';
import { useCallback } from 'react';

export const useDeleteCurrencyRate = (onDeleteCallback: () => void) => {
  const { t } = useTranslation();
  const setErrorNotification = useErrorInlineNotificationAPI();

  const { mutateAsync: _mutateAsync, error } = useDeleteApCurrencyRate();
  const notify = useNotification();
  const { send } = useErrorTrackingSystem();

  if (error) throw error;

  return useCallback(
    async (id: string) => {
      try {
        const results = await _mutateAsync({ id });
        if (isSuccess(results.status)) {
          notify.success({
            title: t('foreign_currency.detail.notification.delete.success'),
            opts: {
              style: {
                position: 'fixed',
              },
            },
          });
          onDeleteCallback();
        } else {
          throw error ? error : results.data;
        }
      } catch (error) {
        if (error instanceof Error) {
          send(error.message);
        } else {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          send(error as Error);
        }
        setErrorNotification(
          new Error(t('foreign_currency.detail.notification.delete.error'))
        );
      }
    },
    [
      _mutateAsync,
      error,
      notify,
      onDeleteCallback,
      send,
      setErrorNotification,
      t,
    ]
  );
};
